import type { JSX } from 'react';
import type { QuestionMedia } from '../types.js';
import { MediaBlock } from './MediaBlock.js';

interface QuestionMediaBlockProps {
  media: QuestionMedia;
  radius: number;
}

export function QuestionMediaBlock({ media, radius }: QuestionMediaBlockProps): JSX.Element | null {
  if (!media?.url) return null;
  return (
    <div style={{ marginTop: 6 }}>
      <MediaBlock
        media={{ url: media.url, type: media.type ?? 'image', alt: media.alt ?? '' }}
        radius={radius}
        maxHeight={media.imageHeight ?? 200}
        fit={media.imageFit ?? 'cover'}
      />
    </div>
  );
}
